import { Modal } from "antd";
import Table from "@common/Table";
import { headerCellRenderer, cellRenderer, smartRound } from "@utils/helpers";
import { useFetchPossibleCorrectImportersExportersQuery } from "@store/advanceSearch";

export default function PopupTable({ visible, onClose, record }) {
  const { data, isLoading, isFetching } =
    useFetchPossibleCorrectImportersExportersQuery({
      id: record?.id,
      matchFieldName: record?.field,
    });

  const columns = [
    {
      title: headerCellRenderer(
        record?.field === "exporter" ? "Manufacturer" : "Consignee",
        "!flex justify-center",
      ),
      dataIndex: record?.field,
      key: record?.field,
      render: (text) => cellRenderer(text),
      onCell: (row) => ({ rowSpan: row._rowSpan }),
    },
    {
      title: headerCellRenderer("Date", "!flex justify-center"),
      dataIndex: "Year",
      key: "Year",
      render: (text) => cellRenderer(text),
    },
    {
      title: headerCellRenderer("Quantity", "!flex justify-center"),
      dataIndex: "Quantity",
      key: "Quantity",
      render: (text) => cellRenderer(text),
    },
  ];

  const transformedData = [];
  data?.data?.forEach((item) => {
    const years = item.years ?? [];
    const rowCount = years.length || 1;

    if (years.length === 0) {
      transformedData.push({
        key: item[record?.field],
        [record?.field]: item[record?.field],
        Year: null,
        Quantity: null,
        _rowSpan: 1,
        _isFirstRow: true,
      });
    } else {
      years.forEach((yearEntry, index) => {
        transformedData.push({
          key: `${item[record?.field]}-${index}`,
          [record?.field]: item[record?.field],
          Year: yearEntry.year,
          Quantity: record.isGramProduct
            ? smartRound(yearEntry.qtyInG)
            : smartRound(yearEntry.qtyInKg),
          _rowSpan: index === 0 ? rowCount : 0,
          _isFirstRow: index === 0,
        });
      });
    }
  });

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <span className="text-base font-semibold text-[#101828]">
            {String(record?.field).charAt(0).toUpperCase() +
              String(record?.field).slice(1)}{" "}
            - {record?.Product}
          </span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
    >
      <div className="mt-4 overflow-hidden border border-gray-200 rounded-lg">
        <Table
          loading={isLoading || isFetching}
          columns={columns}
          dataSource={transformedData}
          pagination={false}
          emptyText="No data to show"
        />
      </div>
    </Modal>
  );
}
